import PouchDB from "pouchdb";
import { DatabaseIdentifier } from "./manager";
import { useCallback, useState } from "react";
import { useHandlePouchChanges } from "./useHandlePouchChanges";

interface PouchBulkChangeReturn<T> {
  execute: (
    docs: (PouchDB.Core.PutDocument<T> | PouchDB.Core.PostDocument<T> | (PouchDB.Core.RemoveDocument & { _deleted: true }))[]
  ) => Promise<({ ok: boolean } & Partial<PouchDB.Core.IdMeta & PouchDB.Core.RevisionIdMeta>)[]>;
  working: boolean;
  error: unknown | null;
}

export function usePouchBulkChange<T>(
  database: PouchDB.Database<T> | undefined,
  dependencies: DatabaseIdentifier[]
): PouchBulkChangeReturn<T> {
  const [working, setWorking] = useState(false);
  const [error, setError] = useState<unknown | null>(null);

  const handlePouchChanges = useHandlePouchChanges();

  const execute = useCallback(
    async (docs: Parameters<PouchBulkChangeReturn<T>["execute"]>[0]) => {
      if (!database) {
        throw new Error("Database not available");
      }
      try {
        setWorking(true);
        setError(null);
        console.log("[POUCH BULKDOCS]", database.name, docs);
        const resp = await database.bulkDocs(docs);
        handlePouchChanges(dependencies).then(() => {});
        return resp.map((r) => ({ ok: "ok" in r ? r.ok : false, _id: r.id, _rev: r.rev }));
      } catch (e) {
        setError(e);
        throw e;
      } finally {
        setWorking(false);
      }
    },
    [database, dependencies, handlePouchChanges]
  );

  return { working, error, execute };
}
